<template>
  <div v-bind:class="drawerClass()">
    <div class="w-[50px] flex flex-col overflow-auto bg-primary-950 items-center py-3 gap-3">
      <div v-for="item in menu.filter((el: any)=>!el?.bottom)">
        <UTooltip
          :text="item.title">
          <UButton v-bind:class="getMenuClass(item)"
              size="xs"
              :icon="item.icon"
              @click="current(item)"
              :current="undefined"
          />
        </UTooltip>
      </div>
      <div class="flex flex-1"></div>
      <div v-for="item in menu.filter((el: any)=>el.bottom)">
        <UTooltip
            :text="item.title">
          <UButton v-bind:class="getMenuClass(item)"
                   size="xs"
                   :icon="item.icon"
                   @click="current(item)"/>
        </UTooltip>
      </div>
    </div>
    <div class="w-[300px] flex flex-col overflow-auto ps-2"
         v-if="expanded">
      <LeftMenuItem v-for="item in getSelectedItems()" :menu="item" :persist="selected?.persist"/>
    </div>
  </div>
</template>

<style scoped >
.left-menu-app {
  background-color: var(--left-menu-background);
}

.button-menu {
  background-color: #172554;
  color: white
}
.button-menu:hover {
  background-color: #1E3A8A
}

.active-menu {
  width: 28px;
  height: 28px;
  background: darkseagreen;
  -moz-border-radius: 25px;
  -webkit-border-radius: 25px;
  border-radius: 25px;
}

</style>
<script setup lang="ts">
import {LeftMenuItem} from "#components";
import {menu} from "@/assets/data/left_menu";
import {PERMISSION_STATE} from "~/states/state";
import {ROUTE_RULES} from "~/routes/route-rules";

const expanded = ref(localStorage.getItem("menuExpanded") == 'true')
const selected = ref()
const permission = useState<any>(PERMISSION_STATE)
const router = useRouter()
const route = useRoute()
const emit = defineEmits<{onExpand: [boolean]}>()

const filteredMenu = computed(()=>{
  let res = menu

  res.forEach((el:any)=>{
    el.items = el.items.filter((i:any)=>{
      if (i.route in ROUTE_RULES) {
        return permission.value.includes(ROUTE_RULES[i.route as keyof typeof ROUTE_RULES])
      } else
        return true
    })
  })

  res = res.filter((m=>m.items.length > 0))

  return res
})

const current = (item: any) => {
  if (!expanded.value || !selected.value || selected.value.title == item.title) {
    expanded.value = !expanded.value
    emit('onExpand', expanded.value)
  }

  if (expanded.value && selected.value.title != item.title){
    let route = item.items[0].items[0].route

    if (!item.persist)
      route = item.items[0].items.sort((a:any,b: any)=>a.title.localeCompare(b.title))[0].route

    navigateTo(route)
  }

  selected.value = item
  localStorage.setItem("menuExpanded", expanded.value.toString())
}

onMounted(async ()=>{
  await router.isReady()
  let path = router.currentRoute.value.fullPath

  if (path == '/login') {
    expanded.value = false
    return
  }

  if (!selected.value) {
    selected.value = menu.find((mi: any)=>{
      return mi.items.find((i:any)=> {
        return i.items.find((ii:any)=>{
           return path.includes(ii.route)
         })
      })
    })
  }
})

watch(
    () => route.fullPath,
    path => {
      selected.value = menu.find((mi: any)=>{
        return mi.items.find((i:any)=> {
          return i.items.find((ii:any)=>{
            return path.includes(ii.route)
          })
        })
      })
    }
)

const getMenuClass = (menu: any) => {
  return selected.value?.title == menu.title ? 'active-menu button-menu'  : 'button-menu'
}

const getSelectedItems = () => {
  if (!selected.value)
    return null

  if (selected.value.persist) return selected.value.items

  return selected.value.items.sort((a:any,b: any)=>a.title.localeCompare(b.title))
}

const drawerClass = () => {
  return `left-menu-app not-selectable inline-flex flex-row overflow-auto mx-2 + ${(expanded.value ? 'min-w-[350px]' : 'min-w-[50px]')}`
}


</script>
